module.exports = __webpack_public_path__ + "static/media/muu.49fdf56e.png";